/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import { Breakpoints } from "constants/Breakpoints";
import Label from "components/Form/Label";

export const Scrollbox = styled.div` 
  overflow-y: auto;
  overflow-x: hidden;

  padding:10px 20px 10px 10px;
  max-height: 300px;

  ::-webkit-scrollbar{
    background:${Colors.WHITE};
    width:8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
`;

export const LabelEdit = styled(Label)`
  font-size: 12px;

  @media screen and (max-width: ${Breakpoints.sm}) {
    width: unset;
    text-align: center;
  }
`;

export const IconSeparator = styled.div`
  display: inline-block;
  background: #888;
  height: 27px;
  width: 2px;
  -webkit-transform: skew(-22deg);
  -ms-transform: skew(-22deg);
  transform: skew(-22deg);
  margin: 0px 6px 2px 6px;
`;

export const InfoReport = styled.p`
  font-family: 'Fira Sans', sans-serif;
`;